import React from "react";
import CustomModalLayout from "../../../../web/Auth/CustomModalLayout";

interface MobileMismatchFoundModalProps {
  open: boolean;
  setOpen: any;
  profileMobile: any;
  applicationMobile: any;
  handleRetryKycRequest: () => void;
}

export default function MobileMismatchFoundModal({
  open,
  setOpen,
  profileMobile,
  applicationMobile,
  handleRetryKycRequest,
}: MobileMismatchFoundModalProps) {
  const maskMobile = (mobile: any) => {
    if (!mobile) return;
    const first4 = mobile.slice(0, 1);
    const last2 = mobile.slice(-1);
    return `+91${first4}********${last2}`;
  };
  return (
    <CustomModalLayout
      open={open}
      onClose={() => {
        // setOpen(false);
      }}
      childrenClassName="pb-6 px-6 lg:px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4 w-full md:w-[420px] overflow-y-scroll max-h-[calc(100%-10px)]"
    >
      <div className="flex flex-col justify-between min-h-[380px]">
        <div className="flex flex-col gap-3">
          <div className="font-semibold text-lg text-brand-textBlack text-center">
            Mobile Number Update Detected
          </div>
          <div className="text-xs text-brand-textGrey text-center">
            Your profile mobile number has changed since you submitted the bid
            participation request.
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="text-sm font-semibold text-brand-textBlack">
              Profile Mobile Number
            </div>
            <div className="text-sm font-semibold text-brand-orange">
              {maskMobile(profileMobile)}
            </div>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="text-sm font-semibold text-brand-textBlack">
              Mobile Number As per application request
            </div>
            <div className="text-sm font-semibold text-green-600">
              {maskMobile(applicationMobile)}
            </div>
          </div>
        </div>
        <div>
          <div className="font-openSans text-xs text-center mb-3">
            Please discard the old application and start over, or contact
            Auction Bazaar support to request a correction.
          </div>
          <div className="font-openSans text-xs text-center"></div>
          <div
            onClick={handleRetryKycRequest}
            className="flex justify-center text-[#1C64F2] underline cursor-pointer font-medium text-xs mt-4"
          >
            Discard Application and Start Over
          </div>
        </div>
        {/* )} */}
      </div>
    </CustomModalLayout>
  );
}
